// Import all required modules
import Header from '@bs/components/views/Header';
import ThemeToggle from '@bs/components/ThemeToggle';
import SearchModal from '@bs/components/views/SearchModal';
import DonutChart from '@bs/components/views/Donut-chart';
import BarChart from '@bs/components/views/Bar-chart';
import Accordion from '@bs/components/views/Accordion';
import VideoYoutube from '@bs/components/views/VideoYoutube';
import VideoModal from '@bs/components/views/VideoModal';
import EqualHeight from '@bs/components/views/equal-height';
import SocialShare from '@bs/components/views/SocialShare';
// import GlossaryPopup from '@bs/components/views/GlossaryPopup';

// Export reference to all modules in an object
export default {
  Accordion,
  Header,
  ThemeToggle,
  SearchModal,
  DonutChart,
  BarChart,
  VideoYoutube,
  VideoModal,
  EqualHeight,
  SocialShare
  // GlossaryPopup
};
